import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  canonical?: string;
  type?: "website" | "article" | "product";
}

const SEO = ({
  title,
  description,
  keywords = "mangimi, animali domestici, allevamento, agricoltura, sementi, magione, perugia, trasimeno, pet food, pellet",
  ogImage = "https://storage.googleapis.com/gpt-engineer-file-uploads/vKF35DqI1Hg2grRJayX0Y6LHbkh1/uploads/1763051793894-favicon-32x32.png",
  canonical,
  type = "website",
}: SEOProps) => {
  const siteUrl = "https://www.mangimirubini.it";
  const fullTitle = `${title} | Mangimi Rubini`;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="Mangimi Rubini" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
